<template>
  <q-dialog v-model="model">
    <q-card style="width: 700px; max-width: 80vw">
      <q-toolbar>
        <q-toolbar-title>
          <q-icon name="favorite" />
          {{ $t('favorite_programmes.title') }}
        </q-toolbar-title>
        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>
      <q-card-section class="q-pa-none">
        <div v-if="favoriteProgrammes.length == 0" class="q-pa-md">
          <div class="text-center text-subtitle1 text-negative">
            <span> {{ $t('favorite_programmes.programs_not_found') }} </span>
          </div>
        </div>
        <q-scroll-area v-else style="height: 500px" class="q-px-md">
          <div
            v-for="(favorite_programme, index) in favoriteProgrammes"
            :key="favorite_programme.id"
          >
            <div v-if="favorite_programme.programme" class="q-py-md">
              <div
                class="row q-col-gutter-md"
                :class="{ 'justify-center': $q.screen.lt.md, 'justify-start': $q.screen.gt.md }"
              >
                <div class="col-12 col-md-4">
                  <div class="column full-height justify-center">
                    <span class="program-title" :class="{ 'text-center': $q.screen.lt.md }">
                      {{ getName(favorite_programme.programme) }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div
                    class="column"
                    :class="{ 'items-center': $q.screen.lt.md, 'items-start': $q.screen.gt.md }"
                  >
                    <q-chip square color="info" text-color="primary" icon="book">
                      {{ getType(favorite_programme.programme) }}
                    </q-chip>
                    <q-chip square icon="local_library" color="info" text-color="primary">
                      {{ getStudyModes(favorite_programme.programme).join('/') }}
                    </q-chip>
                    <q-chip
                      v-if="favorite_programme.programme.languages.includes('English')"
                      icon="language"
                      color="info"
                      text-color="primary"
                      square
                    >
                      {{ $t('programs.lang_label') }}
                    </q-chip>
                    <q-chip square icon="payments" color="info" text-color="primary">
                      {{ getListFees(favorite_programme.programme) }}
                    </q-chip>
                    <q-chip
                      v-for="topic in getTopics(favorite_programme.programme)"
                      :key="topic"
                      square
                      icon="topic"
                      color="info"
                      text-color="primary"
                    >
                      {{ topic }}
                    </q-chip>
                  </div>
                </div>
                <div class="col-12 col-md-2">
                  <div class="column full-height items-center justify-center">
                    <div class="row q-gutter-sm">
                      <q-btn
                        @click="removeFromFavorite(favorite_programme.id)"
                        round
                        size="12px"
                        icon="remove"
                        color="negative"
                      >
                        <q-tooltip>{{ $t('favorite_programmes.remove') }}</q-tooltip>
                      </q-btn>
                      <q-btn
                        @click="navigateToRouteDetails(favorite_programme.programme)"
                        round
                        size="12px"
                        icon="open_in_new"
                        color="positive"
                      >
                        <q-tooltip>{{ $t('favorite_programmes.open') }}</q-tooltip>
                      </q-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <q-separator color="grey-5" v-if="index != favoriteProgrammes.length - 1" />
          </div>
        </q-scroll-area>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { watch } from 'vue'
import { useFavoriteProgrammeStore } from 'stores/favorite_programme-store'

import { useProgrammeLocale } from 'src/composables/programme/useProgrammeLocale'
import { useProgrammeRoute } from 'src/composables/programme/useProgrammeRoute'

const model = defineModel<boolean>({ default: false })

const favoriteProgrammeStore = useFavoriteProgrammeStore()

const { getName, getListFees, getType, getTopics, getStudyModes } = useProgrammeLocale()

watch(
  () => favoriteProgrammeStore.open,
  async (isOpen) => {
    if (isOpen) {
      await favoriteProgrammeStore.initFavoriteProgrammes()
    }
  }
)
const { favoriteProgrammes } = storeToRefs(favoriteProgrammeStore)

const { navigateToRouteDetails } = useProgrammeRoute()

async function removeFromFavorite(id: number) {
  await favoriteProgrammeStore.deleteFavoriteProgramme(id)
}
</script>
